import React, { useCallback, useState } from 'react';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import hasCookieConsent from '%paysera_service_agreement/js/CookiesUserAgreement/service/hasCookieConsent';
import CookieConsentContent from './CookieConsentContent';
import CookieSettingsPortalButton from './CookieSettingsPortalButton';

const BANNER_SX = {
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: theme => theme.zIndex.modal - 1,
};

const BANNER_INNER_SX = {
    mx: 'auto',
    maxWidth: theme => theme.breakpoints.values.lg,
    borderRadius: 0,
    maxHeight: '100vh',
    '@supports (height: 100dvh)': {
        maxHeight: '100dvh',
    },
    overflowY: 'auto',
    overscrollBehavior: 'contain',
};

function CookieConsentBanner() {
    const [open, setOpen] = useState(() => !hasCookieConsent());

    const closeBanner = useCallback(() => setOpen(false), []);
    const openBanner = useCallback(() => setOpen(true), []);

    return (
        <React.Fragment>
            {open && (
                <Box sx={BANNER_SX} data-testid="redesign-cookie-consent-banner">
                    <Paper sx={BANNER_INNER_SX} elevation={4} square>
                        <CookieConsentContent closeBanner={closeBanner} />
                    </Paper>
                </Box>
            )}
            <CookieSettingsPortalButton onClick={openBanner} />
        </React.Fragment>
    );
}

export default React.memo(CookieConsentBanner);
